// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .profile {
  background-color: #f6f3f3;
  padding-left: 20px;
}
.theme-light .profile .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-light .profile .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-light .profile .images .profilePic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.theme-light .profile .profileContainer {
  padding: 20px 70px;
}
@media (max-width: 480px) {
  .theme-light .profile .profileContainer {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-light .profile .profileContainer {
    padding: 20px;
  }
}
.theme-light .profile .profileContainer .uInfo {
  height: 180px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: white;
  color: #000;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media (max-width: 480px) {
  .theme-light .profile .profileContainer .uInfo {
    flex-direction: column;
    height: 30vh;
    padding: 20px;
    margin-top: 100px;
  }
}
.theme-light .profile .profileContainer .uInfo .left {
  flex: 1 1;
  display: flex;
  gap: 10px;
}
@media (max-width: 960px) {
  .theme-light .profile .profileContainer .uInfo .left {
    flex-wrap: wrap;
  }
}
.theme-light .profile .profileContainer .uInfo .left a {
  color: #555;
}
.theme-light .profile .profileContainer .uInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.theme-light .profile .profileContainer .uInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.theme-light .profile .profileContainer .uInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.theme-light .profile .profileContainer .uInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #555;
}
.theme-light .profile .profileContainer .uInfo .center .info .item span {
  font-size: 12px;
}
.theme-light .profile .profileContainer .uInfo .center button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .profile .profileContainer .uInfo .profileButtons {
  flex: 1 1;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media (max-width: 960px) {
  .theme-light .profile .profileContainer .uInfo .profileButtons {
    flex-wrap: wrap;
  }
}
.theme-light .profile .profileContainer .uInfo .profileButtons button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .profile .profileContainer .uInfo .profileButtons a {
  color: #555;
}
.theme-light .profile .profileContainer .uInfo .right {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.theme-dark .profile {
  background-color: #333;
  padding-left: 20px;
}
.theme-dark .profile .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-dark .profile .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-dark .profile .images .profilePic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.theme-dark .profile .profileContainer {
  padding: 20px 70px;
}
@media (max-width: 480px) {
  .theme-dark .profile .profileContainer {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-dark .profile .profileContainer {
    padding: 20px;
  }
}
.theme-dark .profile .profileContainer .uInfo {
  height: 180px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: #222;
  color: #fffef9;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media (max-width: 480px) {
  .theme-dark .profile .profileContainer .uInfo {
    flex-direction: column;
    height: 30vh;
    padding: 20px;
    margin-top: 100px;
  }
}
.theme-dark .profile .profileContainer .uInfo .left {
  flex: 1 1;
  display: flex;
  gap: 10px;
}
@media (max-width: 960px) {
  .theme-dark .profile .profileContainer .uInfo .left {
    flex-wrap: wrap;
  }
}
.theme-dark .profile .profileContainer .uInfo .left a {
  color: #d1d0c9;
}
.theme-dark .profile .profileContainer .uInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.theme-dark .profile .profileContainer .uInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.theme-dark .profile .profileContainer .uInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.theme-dark .profile .profileContainer .uInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #d1d0c9;
}
.theme-dark .profile .profileContainer .uInfo .center .info .item span {
  font-size: 12px;
}
.theme-dark .profile .profileContainer .uInfo .center button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .profile .profileContainer .uInfo .profileButtons {
  flex: 1 1;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media (max-width: 960px) {
  .theme-dark .profile .profileContainer .uInfo .profileButtons {
    flex-wrap: wrap;
  }
}
.theme-dark .profile .profileContainer .uInfo .profileButtons button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .profile .profileContainer .uInfo .profileButtons a {
  color: #d1d0c9;
}
.theme-dark .profile .profileContainer .uInfo .right {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/profile/profile.scss"],"names":[],"mappings":"AAqBI;ECjBA,yBAAA;EACA,kBAAA;AAFJ;AAII;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAFN;AAIM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAFR;AAKM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAHR;AAMI;EACE,kBAAA;AAJN;ADgBE;ECbE;IAII,aAAA;EAHN;AACF;ADgBE;EClBE;IAQI,aAAA;EAFN;AACF;AAIM;EACE,aAAA;EAGA,kDAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAFR;ADRE;ECFI;IAeI,sBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EADR;AACF;AAGQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;AADV;ADhBE;ECcM;IAMI,eAAA;EAAV;AACF;AAEU;EACE,WAAA;AAAZ;AAIQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAFV;AAIU;EACE,eAAA;EACA,gBAAA;AAFZ;AAKU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAHZ;AAKY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAHd;AAKc;EACE,eAAA;AAHhB;AAOU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AALZ;AASQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAPV;ADhEE;ECmEM;IAOI,eAAA;EANV;AACF;AAQU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AANZ;AASU;EACE,WAAA;AAPZ;AAWQ;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AATV;ADlHI;ECjBA,sBAAA;EACA,kBAAA;AAsIJ;AApII;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAsIN;AApIM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAsIR;AAnIM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAqIR;AAlII;EACE,kBAAA;AAoIN;ADxHE;ECbE;IAII,aAAA;EAqIN;AACF;ADxHE;EClBE;IAQI,aAAA;EAsIN;AACF;AApIM;EACE,aAAA;EAGA,kDAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAsIR;ADhJE;ECFI;IAeI,sBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EAuIR;AACF;AArIQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;AAuIV;ADxJE;ECcM;IAMI,eAAA;EAwIV;AACF;AAtIU;EACE,cAAA;AAwIZ;AApIQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAsIV;AApIU;EACE,eAAA;EACA,gBAAA;AAsIZ;AAnIU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAqIZ;AAnIY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAqId;AAnIc;EACE,eAAA;AAqIhB;AAjIU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAmIZ;AA/HQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAiIV;ADxME;ECmEM;IAOI,eAAA;EAkIV;AACF;AAhIU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAkIZ;AA/HU;EACE,cAAA;AAiIZ;AA7HQ;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AA+HV","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.profile {\n  @include themify($themes) {\n    background-color: themed(\"bgSoft\");\n    padding-left: 20px;\n    \n    .images {\n      width: 100%;\n      height: 300px;\n      position: relative;\n\n      .cover {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .profilePic {\n        width: 200px;\n        height: 200px;\n        border-radius: 50%;\n        object-fit: cover;\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin: auto;\n        top: 200px;\n      }\n    }\n    .profileContainer {\n      padding: 20px 70px;\n\n      @include mobile{\n        padding: 10px;\n      }\n\n      @include tablet{\n        padding: 20px;\n      }\n\n      .uInfo {\n        height: 180px;\n        -webkit-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        -moz-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        border-radius: 20px;\n        background-color: themed(\"bg\");\n        color: themed(\"textColor\");\n        padding: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 20px;\n\n        @include mobile{\n          flex-direction: column;\n          height: 30vh;\n          padding: 20px;\n          margin-top: 100px;\n        }\n\n        .left {\n          flex: 1;\n          display: flex;\n          gap: 10px;\n\n          @include tablet{\n            flex-wrap: wrap;\n          }\n\n          a{\n            color: themed(\"textColorSoft\");\n          }\n        }\n\n        .center {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 10px;\n\n          span {\n            font-size: 30px;\n            font-weight: 500;\n          }\n\n          .info {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-around;\n\n            .item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              color: themed(\"textColorSoft\");\n\n              span {\n                font-size: 12px;\n              }\n            }\n          }\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n        }\n\n        .profileButtons {\n          flex: 1;\n          display: flex;\n          gap: 10px;\n          align-items: center;\n\n          @include tablet{\n            flex-wrap: wrap;\n          }\n\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n\n          a{\n            color: themed(\"textColorSoft\");\n          }\n        }\n\n        .right {\n          flex: 1;\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n          gap: 10px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
